import { render, staticRenderFns } from "./ManufacturingLogbookHistoricalPanel.vue?vue&type=template&id=4a793011&scoped=true"
import script from "./ManufacturingLogbookHistoricalPanel.vue?vue&type=script&lang=js"
export * from "./ManufacturingLogbookHistoricalPanel.vue?vue&type=script&lang=js"
import style0 from "./ManufacturingLogbookHistoricalPanel.vue?vue&type=style&index=0&id=4a793011&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a793011",
  null
  
)

export default component.exports